import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";
import { usePopper } from "react-popper";
import { createPortal } from "react-dom";

export default function ItemDescription({ text = "", children }) {
  const [isShowing, setIsShowing] = useState(false);
  const [referenceElement, setReferenceElement] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "left-start",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 5],
        },
      },
    ],
  });

  return (
    <>
      {children ? (
        <div
          ref={setReferenceElement}
          className="h-full w-full"
          onMouseEnter={() => setIsShowing(true)}
          onMouseLeave={() => setIsShowing(false)}
        >
          {children}
        </div>
      ) : (
        <FontAwesomeIcon
          ref={setReferenceElement}
          size="xl"
          className="absolute tracking-widest right-3 top-3 p-1"
          onMouseEnter={() => setIsShowing(true)}
          onMouseLeave={() => setIsShowing(false)}
          icon={faCircleInfo}
        />
      )}
      {isShowing &&
        text &&
        createPortal(
          <div
            ref={setPopperElement}
            className={twMerge(
              "bg-violet-600 z-10 max-w-xs shadow-2xl shadow-black animate-fade-in rounded p-3 text-sm font-semibold"
            )}
            style={styles.popper}
            {...attributes.popper}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}
